import React from 'react';
import { Paper } from '@material-ui/core';

function PchPaper({ children, ...props }) {
	return (
		<Paper {...props} className={`p-8 w-full my-4 rounded filter drop-shadow `} elevation={0}>
			<div className={props.className}>{children}</div>
		</Paper>
	);
}

export default PchPaper;
